<h2 class="text-primary heading" mat-dialog-title>{{ data.Title }}</h2>
<mat-dialog-content>
  <ng-container [ngTemplateOutlet]="data.innerContent"> </ng-container>
</mat-dialog-content>
<mat-dialog-actions align="end">
  @if (data.cancelButton) {
    <button class="btn-md-outlined-error me-2" tabindex="-1" [mat-dialog-close]="false" matRipple>{{ data.cancelButton }}</button>
  }
  @if (data.okButton) {
    <button class="btn-md-filled-primary" [mat-dialog-close]="true" matRipple>{{ data.okButton }}</button>
  }
</mat-dialog-actions>
